import { createStore, createEvent } from "effector";
import { FraudBlock, Page } from "../../types/fraud.types";
import { fraudBlocksStoreState } from "./FraudBlocksStore.consts";
import { FraudBlocksStoreState } from "./FraudBlocksStore.types";
import { getFraudBlocksEffect, unblockFraudEffect } from "./FraudBlocksStore.effects";

// Eventos (ações)
export const resetFraudBlocksStore = createEvent();

// Store inicial
export const FraudBlocksStore = createStore<FraudBlocksStoreState>(fraudBlocksStoreState)
  .on(getFraudBlocksEffect.doneData, (store, page: Page<FraudBlock>) => ({
    ...store,
    blocks: page.content,
    page: page.number,
    size: page.size,
    totalElements: page.totalElements,
    totalPages: page.totalPages,
  }))
  .on(unblockFraudEffect.doneData, (store, cpf: string) => ({
    ...store,
    blocks: store.blocks.filter((block) => block.cpf !== cpf),
    totalElements: Math.max(0, store.totalElements - 1),
  }))
  .reset(resetFraudBlocksStore);
